import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
// The following line was causing a compilation error.
// import 'react-toastify/dist/ReactToastify.css';

const AddLeadsForm = ({ closeModal, onLeadsUpdated }) => {
  // A helper function to get initial data from session storage or use a default
  const getInitialLeadData = () => {
    try {
      const storedData = sessionStorage.getItem("leadFormData");
      return storedData ? JSON.parse(storedData) : {
        LeadsName: "",
        leadType: "",
        company: "",
        group: "",
        Email: "",
        contact: "",
        contactalt: "",
        building: "",
        street: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
      };
    } catch (error) {
      console.error("Failed to parse lead data from session storage:", error);
      return {
        LeadsName: "",
        leadType: "",
        company: "",
        group: "",
        Email: "",
        contact: "",
        contactalt: "",
        building: "",
        street: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
      };
    }
  };

  const [leadData, setLeadData] = useState(getInitialLeadData);

  // Use useEffect to save form data to session storage whenever leadData changes
  useEffect(() => {
    sessionStorage.setItem("leadFormData", JSON.stringify(leadData));
  }, [leadData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeadData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token"); // 🔑 CHANGE: Use real token

    try {
      // 🔑 CHANGE: Replace mock call with real axios.post
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/Leads`, leadData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      toast.success("Lead added successfully!");
      
      // 🔑 CHANGE: Call the callback function to refresh the list
      if (onLeadsUpdated) {
        onLeadsUpdated();
      }

      // Clear session storage on successful submission
      sessionStorage.removeItem("leadFormData");

      // Reset form
      setLeadData({
        LeadsName: "",
        leadType: "",
        company: "",
        group: "",
        Email: "",
        contact: "",
        contactalt: "",
        building: "",
        street: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
      });

      if (closeModal) closeModal();
    } catch (error) {
      console.error("Error adding lead:", error);
      toast.error("Failed to add lead. Please try again.");
    }
  };

  return (
    <div className="w-full bg-white shadow-lg rounded-lg p-6 mx-auto mt-1">
      <h2 className="text-2xl font-semibold text-center mb-6">Add Lead</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Lead Info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-4 mb-4">
            <label className="block text-sm font-medium text-gray-700">Lead Type</label>
            <select
              name="leadType"
              value={leadData.leadType}
              onChange={handleChange}
              required
              className="mt-1 p-2 border rounded-md w-full"
            >
              <option value="">Select a lead type</option>
              <option value="Cold Leads">Cold Lead - Never interacted with OneHub</option>
              <option value="Warm Leads">Warm Leads - Showed interest but no commitment</option>
              <option value="Hot Leads">Hot Leads - Ready to purchase</option>
              <option value="Referral Leads">Referral Leads - Sent by customers or partners</option>
              <option value="Inbound Leads">Inbound Leads - Found us through content or ads</option>
              <option value="Revival Leads">Revival Leads - Past leads that went cold</option>
            </select>
          </div>

          <div className="p-4 mb-4">
            <label className="block text-sm font-medium text-gray-700">Lead Name</label>
            <input
              type="text"
              name="LeadsName"
              value={leadData.LeadsName}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              className="mt-1 p-2 border rounded-md w-full"
              placeholder="Enter lead name"
            />
          </div>
        </div>

        {/* Company and Group */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-4 mb-4">
            <label className="block text-sm font-medium text-gray-700">Company</label>
            <input
              type="text"
              name="company"
              value={leadData.company}
              onChange={handleChange}
              className="mt-1 p-2 border rounded-md w-full"
              placeholder="Enter company name"
            />
          </div>

          <div className="p-4 mb-4">
            <label className="block text-sm font-medium text-gray-700">Group</label>
            <input
              type="text"
              name="group"
              value={leadData.group}
              onChange={handleChange}
              className="mt-1 p-2 border rounded-md w-full"
              placeholder="Enter group name (optional)"
            />
          </div>
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-4 mb-4">
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              name="Email"
              value={leadData.Email}
              onChange={handleChange}
              required
              placeholder="Enter email address"
              className="mt-1 p-2 border rounded-md w-full"
            />
          </div>

          <div className="p-4 mb-4">
            <label className="block text-sm font-medium text-gray-700">Contact</label>
            <input
              type="tel"
              name="contact"
              value={leadData.contact}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              maxLength={10}
              pattern="\d{10}"
              inputMode="numeric"
              className="mt-1 p-2 border rounded-md w-full"
              placeholder="Enter 10-digit mobile number"
            />
          </div>
        </div>

        <div className="bg-gray-50 p-4 mb-4 rounded-md grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Alternate Contact</label>
            <input
              type="tel"
              name="contactalt"
              value={leadData.contactalt}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              maxLength={10}
              pattern="\d{10}"
              inputMode="numeric"
              className="mt-1 p-2 border rounded-md w-full"
              placeholder="Enter 10-digit mobile number"
            />
          </div>
        </div>

        {/* Address Information */}
        <div className="bg-gray-50 p-4 mb-4 rounded-md">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Building</label>
              <input
                type="text"
                name="building"
                value={leadData.building}
                onChange={handleChange}
                required
                className="mt-1 p-2 border rounded-md w-full"
                placeholder="Enter building name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Street</label>
              <input
                type="text"
                name="street"
                value={leadData.street}
                onChange={handleChange}
                required
                className="mt-1 p-2 border rounded-md w-full"
                placeholder="Enter street name"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">City</label>
              <input
                type="text"
                name="city"
                value={leadData.city}
                onChange={handleChange}
                required
                className="mt-1 p-2 border rounded-md w-full"
                placeholder="Enter city name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">State</label>
              <input
                type="text"
                name="state"
                value={leadData.state}
                onChange={handleChange}
                required
                className="mt-1 p-2 border rounded-md w-full"
                placeholder="Enter state name"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">District</label>
            <textarea
              name="district"
              value={leadData.district}
              onChange={handleChange}
              required
              className="mt-1 p-2 border rounded-md w-full"
              placeholder="Enter district name"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Pincode</label>
              <input
                type="number"
                name="pincode"
                value={leadData.pincode}
                onChange={handleChange}
                required
                className="mt-1 p-2 border rounded-md w-full"
                placeholder="Enter pincode"
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-green-600 text-white p-3 rounded-md hover:bg-green-700 transition duration-300"
        >
          Submit Lead
        </button>
      </form>
    </div>
  );
};

export default AddLeadsForm;
